var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockedIco(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C9.79971 2 8 3.79971 8 6V8H6.25C5.0095 8 4 9.0095 4 10.25V19.75C4 20.9905 5.0095 22 6.25 22H17.75C18.9905 22 20 20.9905 20 19.75V10.25C20 9.0095 18.9905 8 17.75 8H16V6C16 3.79971 14.2003 2 12 2ZM12 3.5C13.3897 3.5 14.5 4.61029 14.5 6V8H9.5V6C9.5 4.61029 10.6103 3.5 12 3.5ZM12 13.5C12.8285 13.5 13.5 14.1715 13.5 15C13.5 15.8285 12.8285 16.5 12 16.5C11.1715 16.5 10.5 15.8285 10.5 15C10.5 14.1715 11.1715 13.5 12 13.5Z",
    fill: "#0A0A0A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedIco);
export default __webpack_public_path__ + "static/media/locked-ico.40458d95.svg";
export { ForwardRef as ReactComponent };